import {
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  RESET_PASSWORD_STATE,
} from '../types/AuthTypes';

const initialState = {
  loading: false,
  success: null,
  error: null,
};

const resetPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
      return { ...state, loading: true, success: false, error: null };
    case RESET_PASSWORD_SUCCESS:
      return { ...state, loading: false, success: action.payload, error: null };
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        success: null,
        error: action.payload,
      };
    case RESET_PASSWORD_STATE:
      return { ...state, loading: false, success: null, error: null };
    default:
      return state;
  }
};

export default resetPasswordReducer;
